// 前端功能开关（管理员可控）。
// 钱包相关页面当前未启用，默认在导航中隐藏；管理员可通过设置开关显示。
// 开关持久化在 localStorage，键名 vtm-flag-<name>。
const PREFIX = "vtm-flag-";

export const getFlag = (name, defaultValue = false) => {
  try {
    const v = localStorage.getItem(PREFIX + name);
    if (v === "true") return true;
    if (v === "false") return false;
  } catch (e) {
    /* ignore */
  }
  return defaultValue;
};

export const setFlag = (name, value) => {
  try {
    localStorage.setItem(PREFIX + name, value ? "true" : "false");
  } catch (e) {
    /* ignore */
  }
};

// 钱包模块是否在导航中可见（默认隐藏）
export const isWalletVisible = () => getFlag("wallet-visible", false);

// 便于管理员在控制台切换：window.__vtmWallet(true|false) 后刷新
if (typeof window !== "undefined") {
  window.__vtmWallet = show => {
    setFlag("wallet-visible", !!show);
    return `Wallet nav ${show ? "enabled" : "hidden"}. Reload to apply.`;
  };
}

export default { getFlag, setFlag, isWalletVisible };
